import Shared from './shared';

export default {
  Shared,
};
